import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'
import CustomInput from '../general/Form'
import { useApi } from '../../hooks/useApi'

interface TokenListFormProps {
  onSuccess?: () => void
}

const TokenListForm: React.FC<TokenListFormProps> = ({ onSuccess = () => {} }) => {
  const [name, setName] = useState('')
  const [url, setUrl] = useState('')
  const [message, setMessage] = useState('')
  const { callApi } = useApi()

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      await callApi('/token-registry/lists', { name, url, isActive: true, lastUpdate: moment().toISOString() }, 'POST')
      onSuccess()
    } catch (error) {
      console.error('Error creating token:', error)
    }
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      {message !== '' ? (
        <FeedbackBanner>
          <span>{message}</span>
          <CloseBtn onClick={() => setMessage('')}>✕</CloseBtn>
        </FeedbackBanner>
      ) : (
        <>
          <FormTitle>New token list</FormTitle>
          <FieldGrid>
            <CustomInput label="Name" name="Name" type="text" modal value={name} onChange={(e: any) => setName(e.target.value)} required />
            <CustomInput label="URL" name="Url" type="text" modal value={url} onChange={(e: any) => setUrl(e.target.value)} required />
          </FieldGrid>
          <SubmitBtn type="submit">Add token list</SubmitBtn>
        </>
      )}
    </Form>
  )
}

export default TokenListForm

// ─── Styles ──────────────────────────────────────────────────────────────────

const Form = styled.form`display: flex; flex-direction: column; gap: 16px;`
const FormTitle = styled.h2`font-size: 14px; font-weight: 600; color: #ededed; margin: 0;`
const FieldGrid = styled.div`display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 8px; align-items: start;`
const SubmitBtn = styled.button`height: 34px; padding: 0 16px; align-self: flex-start; background: rgba(111,92,230,0.15); border: 1px solid rgba(111,92,230,0.35); border-radius: 6px; color: #a89aff; font-size: 13px; font-weight: 500; cursor: pointer; transition: background 0.15s, border-color 0.15s; &:hover { background: rgba(111,92,230,0.25); border-color: rgba(111,92,230,0.5); }`
const FeedbackBanner = styled.div`display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: rgba(51,194,176,0.08); border: 1px solid rgba(51,194,176,0.25); border-radius: 6px; color: #33C2B0; font-size: 13px;`
const CloseBtn = styled.button`background: transparent; border: none; color: inherit; cursor: pointer; font-size: 12px; opacity: 0.7; &:hover { opacity: 1; }`
